import { useEffect } from "react";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const useCancelarAndamento = ({ data }) => {
  const {
    request: cancelarRequest,
    data: cancelarData,
    errors: cancelarErrors,
    isLoading: cancelarIsLoading,
  } = useApiClient();

  const cancelarAndamento = () => {
    const parametros = {
      sequencialAcaoFiscal: data.dadosOs.acaoFiscal,
      sequencialProdutoAcaoFiscal: data.sequencialAuto,
      sequencialAndamento: data.sequencialUltimoAndamento,
      sequencialAtividade: data.sequencialUltimaAtividade,
    };

    cancelarRequest(apiRoutes.fiscalizacao.autoinfracao.cancelarAndamento, parametros);
  };

  useEffect(() => {
    if (cancelarIsLoading) return;

    if (!cancelarData && !cancelarErrors) return;

    if (cancelarData) {
      toast.success("Atividade cancelada com sucesso.");
      window.location.reload();
    }
  }, [cancelarData, cancelarErrors, cancelarIsLoading]);

  return { cancelarAndamento, cancelarErrors, cancelarIsLoading };
};

export default useCancelarAndamento;
